<div class="Footer">
  <div class="Footer_wrapper container py-5">
    <div class="d-flex flex-column flex-sm-row">
      <div class="Footer_wrapper_container flex-grow-1 m-auto m-sm-0">
        <h3>Navigation</h3>
        <ul class="ps-0">
          <li class="" *ngFor="let item of navigationLinks">
            <a [routerLink]="[item.target]">{{ item.label }}</a>
          </li>
        </ul>
      </div>
      <div class="Footer_wrapper_container flex-grow-1 m-auto m-sm-0">
        <h3>Support</h3>
        <ul class="ps-0">
          <li *ngFor="let item of supportLinks">
            <a [routerLink]="[item.target]">{{ item.label }}</a>
          </li>
          <li>
            <a href="https://click2sell.zendesk.com/hc/en-us" target="_blank"
              >Support</a
            >
          </li>
        </ul>
      </div>
      <div class="Footer_wrapper_container flex-grow-1 m-auto m-sm-0">
        <h3>Social Media</h3>
        <ul class="ps-0">
          <li>
            <a
              href="https://www.linkedin.com/company/click2sell-com"
              target="_blank"
              >LinkedIn</a
            >
          </li>
        </ul>
      </div>
      <div class="Footer_wrapper_container flex-grow-1 m-auto m-sm-0">
        <img src="/assets/images/retail/footlogo.png" alt="Click2 Sell Logo" />
      </div>
    </div>
  </div>
</div>
